// "+ Agregar" en las referencias de la card de imagen —
// ADR-2026-10-20-las-referencias-de-la-card-se-editan.
//
// La card vive en `ChatPanelV2`, que también se monta fuera del chat de Atlas, y el selector
// de fuentes (`ModalDeFuentes`) es del chat de Atlas, que ya importa `ChatPanelV2`. Para no
// cerrar un ciclo de imports, el chat de Atlas ofrece ABRIR el selector por contexto y la card
// lo pide: sin contexto (fuera del chat de Atlas) no hay "+ Agregar".

import { createContext, useContext } from 'react';
import type { ChatAttachment } from './agentAttachments';

export type AbrirSelectorDeReferencias = (onElegido: (adjunto: ChatAttachment) => void) => void;

export const SelectorDeReferenciasContext = createContext<AbrirSelectorDeReferencias | null>(null);

export const useSelectorDeReferencias = (): AbrirSelectorDeReferencias | null => useContext(SelectorDeReferenciasContext);
